/**
 * A visitor converted: the journey that led here is spent, and a clinic page
 * hosting this one in a frame hears about it so its own tags can count it.
 *
 * Only ids and amounts travel to the host — never who booked or what for: the
 * host page hands these to ad pixels, and a treatment name is health data.
 */
import { consumeMarketingAttribution } from "@/lib/marketing-attribution";

export type ConversionName =
  | "booking_completed"
  | "purchase_completed"
  | "lead_submitted";

export interface ConversionDetail {
  /** Stable per conversion, so a pixel and a server event can be matched. */
  eventId?: string;
  value?: number;
  currency?: string;
}

/** Message decoda.js on the clinic's site listens for. */
export const CONVERSION_MESSAGE = "DECODA_CONVERSION";

export function recordConversion(
  name: ConversionName,
  detail: ConversionDetail = {},
): void {
  consumeMarketingAttribution();
  try {
    if (window.parent !== window) {
      window.parent.postMessage(
        { type: CONVERSION_MESSAGE, name, detail },
        "*",
      );
    }
  } catch {
    // Telling the host is a courtesy; it must never break the confirmation.
  }
}
